import React, { useContext, useState } from 'react'
import { AuthContext } from '../../../../../auth-context'
import styled from 'styled-components'
import _ from 'lodash'
import { assignToGroup, removeFromGroup } from '../../../../../api'
import Popover from '@material-ui/core/Popover'
import Checkbox from '@material-ui/core/Checkbox'
import { withStyles } from '@material-ui/core/styles'

const WhiteCheckbox = withStyles({
  root: {
    color: "#FFF",
    "&$checked": {
      color: "#FFF",
    },
  },
  checked: {},
})((props) => <Checkbox {...props} />)

const CustomPopover = withStyles({
  paper: {
    background: "#060c29",
    borderRadius: "12px",
  },
})(Popover)

const Item = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  p {
    color: #fff;
    white-space: nowrap;
    padding: 0px 0px 0px 18px;
  }
`

const Content = styled.div`
  color: #fff;
  padding: 6px;
  max-height: 360px;
`

const Button = styled.button`
  border: none;
  background: none;
  width: 100%;
  flex-basis: content;

  svg {
    color: #fff;
  }
`

const ListItem = ({ name, checked, onChange }) => {
  return (
    <Item>
      <p>{name}</p>
      <WhiteCheckbox
        checked={checked}
        onChange={onChange}
        inputProps={{ "aria-label": "checkbox" }}
      />
    </Item>
  );
}

export const GroupButton = ({button, accountID, assignedGroups}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const { user, updateUser } = useContext(AuthContext)
  const open = Boolean(anchorEl)

  const handleChange = (isAssigned, groupID) => {
    if (isAssigned) {
      removeFromGroup(user.id, accountID, groupID)
        .then(function (response) {
          let newUser = _.cloneDeep(user)
          const newAssignedGroups = _.without([...assignedGroups], groupID)
          const groupIndex = newUser.groups.findIndex(u => u.id === groupID)
          const accountIndex = newUser.accounts.findIndex(u => u.id === accountID)
          newUser.groups[groupIndex].client_count = newUser.groups[groupIndex].client_count - 1
          newUser.accounts[accountIndex].groups = newAssignedGroups
          updateUser(newUser)     
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
    } else {
      assignToGroup(user.id, accountID, groupID)
        .then(function (response) {
          let newUser = _.cloneDeep(user)
          const newAssignedGroups = [...assignedGroups]
          const groupIndex = newUser.groups.findIndex(u => u.id === groupID)
          const accountIndex = newUser.accounts.findIndex(u => u.id === accountID)
          newAssignedGroups.push(groupID)
          newUser.groups[groupIndex].client_count = newUser.groups[groupIndex].client_count + 1
          newUser.accounts[accountIndex].groups = newAssignedGroups
          updateUser(newUser)   
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
    }
  }

  return (
    <>
      <Button onClick={(e) => setAnchorEl(e.currentTarget)}>
        {button}
      </Button>
      <CustomPopover
        id={accountID}
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl("")}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Content>
          {user.groups.length !== 0 ?
            user.groups.map((group, index) => 
              <ListItem
                key={group.id}
                name={group.name}
                checked={assignedGroups ? assignedGroups.includes(group.id) : false}
                onChange={() => handleChange(assignedGroups.includes(group.id), group.id)}
              />
            )
          :
            <p>No groups have been added.</p>
          }
        </Content>
      </CustomPopover>
    </>
  )
}